import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mock';
import { 
  MessageSquare, 
  Briefcase, 
  Building, 
  FileText, 
  Gavel, 
  Users2, 
  Scale, 
  DollarSign 
} from 'lucide-react';

const iconMap = [
  MessageSquare,
  Briefcase,
  Building,
  FileText,
  Gavel,
  Users2,
  Scale,
  DollarSign
];

const Services = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-amber-50 rounded-full mb-6">
            <span className="text-amber-600 font-semibold text-sm">{t.services.title}</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {t.services.title}
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            {t.services.subtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.services.items.map((service, index) => {
            const Icon = iconMap[index];
            return (
              <div
                key={service.id}
                className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-slate-200 hover:border-amber-500 hover:-translate-y-2"
              >
                <div className="mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl flex items-center justify-center group-hover:from-amber-500 group-hover:to-amber-600 transition-all duration-300">
                    <Icon className="w-8 h-8 text-amber-600 group-hover:text-white transition-colors" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-amber-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;